'use client';
import type { ReactNode } from 'react';
import { Wrapper } from '@/components/moleculer/events/2024techfes/wrapper';
import { Events } from '@/components/moleculer/events/2024techfes/events';
import { AboutLecture } from '@/components/moleculer/events/2024techfes/lecture/aboutLecture';
import { useRouter } from 'next/navigation';

const Detail = async (): Promise<ReactNode> => {
  const router = useRouter();
  return (
    <Wrapper>
      <div className={'flex flex-col bg-black'}>
        <div className={'flex flex-col'}>
          <AboutLecture />
          <Events />
        </div>
        <button
          type="button"
          className={
            'bg-white text-black px-8 py-2 w-fit mx-auto text-2xl rounded mb-10'
          }
          onClick={(): void => {
            router.push('/events/2024techfes/detail');
          }}
        >
          イベントTOPに戻る
        </button>
      </div>
    </Wrapper>
  );
};
export default Detail;
